import { render, staticRenderFns } from "./IPQCQrcode.vue?vue&type=template&id=09fc9c3d&scoped=true"
import script from "./IPQCQrcode.vue?vue&type=script&lang=js"
export * from "./IPQCQrcode.vue?vue&type=script&lang=js"
import style0 from "./IPQCQrcode.vue?vue&type=style&index=0&id=09fc9c3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc9c3d",
  null
  
)

export default component.exports